<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">TFRs</h2>
  </div>
  <div class="section__body">
    <div class="tfrs__container">
      <div class="tfrs__location_container">
        <div class="tfrs__location">Location: <span class="tfrs__text-value">{{ airport.faaId }}</span></div>
        <div class="tfrs__verify-text">Please verify all content below using the <a class="tfrs__faalink" target="_blank" href="https://tfr.faa.gov/tfr3/?page=list">FAA TFR Search Site</a> or with a flight briefer.</div>
      </div>
      <div class="tfrs__countline">TFR count: <span class="tfrs__text-value">{{airport.tfrs.length}}</span> <span *ngIf="airport.tfrs.length > 0" class="tfrs__fulllisttext"> (Partial information shown. Follow links to see full TFR descriptions.)</span></div>
    </div>
    <table *ngIf="airport.tfrs.length > 0; else placeholder" class="data-block data-block--lg">
      <thead>
      <tr>
        <th class="tfrs__column-number">Number:</th>
        <th class="tfrs__column-date">Effective Date:<br />(UTC)</th>
        <th class="tfrs__column-date">Expiration Date:<br />(UTC)</th>
        <th class="tfrs__column-condition">Description:</th>
      </tr>
      </thead>
      <tbody>
      <tr class="data-block__item"
          [class.tfrs__active-tfr-row]="getTFRStatus(tfr) == 'ACTIVE'"
          [class.tfrs__scheduled-tfr-row]="getTFRStatus(tfr) == 'SCHEDULED'"
          *ngFor="let tfr of getTFRs(); let i = index">
        <td class="tfrs__data-value-number">
          <div class="tfrs__tfr-text" [class.tfrs__active-tfr-text]="getTFRStatus(tfr) == 'ACTIVE'">{{ getTFRStatus(tfr) }}<br /></div>
          {{ tfr.notamId }}
        </td>
        <td class="tfrs__data-value">
          {{ tfr.effectiveDate | date: 'MM/dd/yyyy HHmm' }}
        </td>
        <td class="tfrs__data-value">
          {{ tfr.expirationDate | date: 'MM/dd/yyyy HHmm' }}
        </td>
        <td class="tfrs__data-value-condition">
          {{ tfr.report | slice: 0: 118}}<br />
          <div class="tfrs__text-link-container">
            <a class="tfrs__text-link-first" (click)="showTFRDetails(tfr)">See Full Text</a>
            <span>|</span>
            <a class="tfrs__text-link" target="_blank" href="{{tfr.tfrFaaUrl}}">View on FAA TFR Site</a>
            <span>|</span>
            <a *ngIf="isMember" class="tfrs__text-link-last" target="_blank" href="{{tfr.tfrIFlightPlannerForAopaUrl}}">View in iFlightPlanner for AOPA</a>
            <a *ngIf="!isMember && isLoggedIn" class="tfrs__text-link-last" target="_blank" href="https://www.aopa.org/account/multipagejoin">Join AOPA to View in iFlightPlanner</a>
            <a *ngIf="!isLoggedIn" class="tfrs__text-link-last" href="https://www.aopa.org/login">Login to view in iFlightPlanner</a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">No TFRs were found for {{airport.identifier}}. Please verify using the <a class="tfrs__faalink" target="_blank" href="https://tfr.faa.gov/tfr3/?page=list">FAA TFR Search Site</a> or with a flight briefer.</div>
  </div>
</ng-template>
